module.exports = __webpack_public_path__ + "static/media/5463x3418.516926c6.jpg";